// Components
import MobileDeviceDetector from "components/common/mobiledetector/MobileDeviceDetector";

// Utils
import { cn } from "utils/cn";
import { LoaderV2, LoaderMode } from "components/common/LoaderV2/LoaderV2";

interface PageLayoutProps {
  id?: string;
  sidebar?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  isLoading?: boolean;
}

export const PageLayoutId = "page-layout";

export const PageLayout = ({
  id,
  sidebar,
  children,
  className,
  isLoading = false,
}: PageLayoutProps) => {
  return (
    <>
      {sidebar && sidebar}
      <div
        id={id || PageLayoutId}
        className={cn(
          "z-0 min-h-0 min-w-0 h-[calc(100svh-54px)] rounded-none p-0 bg-opacity-0 border-y-0 w-full px-4 sm:px-10 flex flex-col overflow-x-hidden overflow-y-auto",
          className
        )}
      >
        <MobileDeviceDetector inproject={true} />
        {isLoading ? <LoaderV2 mode={LoaderMode.screen} /> : children}
      </div>
    </>
  );
};
